import axios from 'axios';

const apiFxAdmin = axios.create({
  baseURL: process.env.REACT_APP_API_FXADMIN,
});

export default apiFxAdmin;
